'use client';

import MenuDropdownButton from '@/components/ui/navigation/top-menu/top-menu-dropdown-button';
import { useSearchParams, usePathname } from 'next/navigation';
import { useEffect, useState, useTransition } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import EarthIcon from './earth-icon';
import {
    getLocalizedPathname,
    LOCALE_SCROLL_RESTORE_KEY,
} from '@/app/lib/utils/scroll-restoration';

function LeftIcon({ textColor }: Readonly<{ textColor: string }>) {
    return (
        <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill={textColor}
        >
            <path d="M903.253333 512c0-88.746667-30.293333-173.653333-84.906666-242.773333l0.853333-0.853334-19.626667-21.76a390.912 390.912 0 0 0-284.586666-125.866666c-0.853333 0-1.706667-0.426667-2.986667-0.426667-0.853333 0-2.133333 0.426667-2.986667 0.426667-12.373333 0-25.173333 0.853333-37.546666 2.133333-18.346667 2.133333-36.266667 5.546667-53.76 9.813333-47.36 11.946667-92.586667 32-132.266667 60.16-22.186667 15.786667-42.666667 33.706667-61.013333 53.76l-20.053334 21.76 0.853334 0.853334A390.826667 390.826667 0 0 0 120.32 512c0 88.746667 30.293333 173.653333 84.906667 242.773333l-0.853334 0.853334 20.053334 21.76a391.68 391.68 0 0 0 284.586666 125.866666c0.853333 0 2.133333 0.426667 2.986667 0.426667 0.853333 0 1.706667-0.426667 2.986667-0.426667a390.4 390.4 0 0 0 284.586666-125.866666l19.626667-21.76-0.853333-0.853334A388.266667 388.266667 0 0 0 903.253333 512z m-129.706666 196.693333c-28.16-25.6-60.16-46.506667-93.866667-62.293333 6.826667-43.52 10.666667-89.173333 10.666667-133.973333 0-44.8-3.413333-90.453333-10.666667-133.973334 34.133333-16.213333 65.706667-37.12 93.866667-62.293333a325.12 325.12 0 0 1 66.133333 196.693333 329.173333 329.173333 0 0 1-66.133333 195.84z m-44.373334 47.786667c-2.56 2.133333-5.546667 4.266667-8.106666 6.826667-5.546667 4.693333-11.093333 8.96-16.64 13.226666-3.413333 2.56-6.826667 4.693333-10.24 6.826667-5.546667 3.84-11.093333 7.253333-16.64 10.666667-3.84 2.133333-7.68 4.266667-11.093334 6.4-5.546667 2.986667-11.093333 5.973333-17.066666 8.533333-3.84 1.706667-8.106667 3.413333-11.946667 5.12-3.84 1.706667-8.106667 2.986667-11.946667 4.693333 17.066667-30.293333 30.72-66.986667 40.96-107.946666 23.04 12.373333 44.8 26.88 64 44.8-0.426667 0.426667-0.853333 0.853333-1.28 0.853333z m-354.133333 52.48c-5.546667-2.56-11.52-5.546667-17.066667-8.533333-3.84-2.133333-7.68-3.84-11.093333-6.4-5.546667-3.413333-11.093333-6.826667-16.64-10.666667-3.413333-2.133333-6.826667-4.266667-10.24-6.826667-5.973333-4.266667-11.52-8.96-17.066667-13.653333-2.56-2.133333-5.546667-4.266667-8.106666-6.826667l-1.28-1.28c19.626667-17.92 41.386667-32.426667 64.426666-44.8 10.24 40.96 24.32 77.653333 41.386667 108.373334-4.266667-1.706667-8.106667-2.986667-12.373333-4.693334a41.002667 41.002667 0 0 1-11.946667-4.693333zM398.08 512c0-40.533333 2.56-77.653333 7.253333-111.36 34.56 9.813333 70.4 15.36 106.666667 15.36 36.266667 0 72.106667-5.546667 106.666667-15.36 4.693333 33.706667 7.253333 70.826667 7.253333 111.36s-2.56 77.653333-7.253333 111.36c-34.56-9.813333-69.973333-15.36-106.666667-15.36-36.266667 0-72.106667 5.546667-106.666667 15.36-4.693333-33.706667-7.253333-70.826667-7.253333-111.36zM294.826667 267.093333c2.56-2.56 5.546667-4.266667 8.106666-6.826666 5.546667-4.266667 11.093333-8.96 17.066667-13.226667 3.413333-2.56 6.826667-4.693333 10.24-6.826667 5.546667-3.84 10.666667-7.253333 16.213333-10.666666l11.52-6.4c5.546667-2.986667 11.093333-5.973333 17.066667-8.533334 3.84-1.706667 8.106667-3.413333 11.946667-5.12 3.84-1.706667 8.106667-2.986667 11.946666-4.693333-17.066667 30.72-30.72 67.413333-41.386666 108.373333-22.613333-11.946667-44.373333-26.88-64-44.8l1.28-1.28z m354.133333-52.053333c5.973333 2.56 11.52 5.546667 17.066667 8.533333 3.84 2.133333 7.68 3.84 11.093333 5.973334 5.546667 3.413333 11.093333 6.826667 16.64 10.666666 3.413333 2.133333 6.826667 4.266667 9.813333 6.826667 5.973333 4.266667 11.52 8.96 17.066667 13.653333l7.68 6.4c0.426667 0.426667 0.853333 0.853333 1.28 0.853334-19.626667 17.493333-41.386667 32.426667-64 44.8-10.24-40.533333-23.893333-77.226667-40.96-107.946667 4.266667 1.706667 8.106667 2.986667 11.946667 4.693333l12.373333 5.546667z m-138.666667-30.293333h2.986667c31.573333 1.706667 70.826667 57.173333 93.44 152.746666-30.293333 9.386667-62.293333 14.506667-94.72 14.506667-32.853333 0-64.853333-5.12-95.146667-14.08 23.04-96 61.866667-151.466667 93.44-153.173333zM512 672c32.426667 0 64.426667 5.12 94.72 14.506667-22.613333 96-61.866667 151.04-93.44 152.746666h-2.986667c-31.573333-1.706667-70.826667-57.173333-93.44-153.173333 30.293333-8.96 62.293333-14.08 95.146667-14.08zM250.453333 315.306667c28.16 25.6 60.16 46.08 94.293334 62.293333-6.826667 43.52-10.666667 89.173333-10.666667 134.4s3.84 90.88 10.666667 134.4c-34.133333 16.213333-65.706667 37.12-94.293334 62.293333A325.12 325.12 0 0 1 184.32 512c0-71.253333 23.466667-139.946667 66.133333-196.693333z"></path>
        </svg>
    );
}

function SelectedIcon() {
    return (
        <svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
        >
            <path d="M840.832 311.168a42.666667 42.666667 0 0 1 0 60.330667l-384 384a42.666667 42.666667 0 0 1-60.330667 0l-213.333333-213.333334a42.666667 42.666667 0 1 1 60.330667-60.330666L426.666667 665.002667l353.834666-353.834667a42.666667 42.666667 0 0 1 60.330667 0z"></path>
        </svg>
    );
}

const languageOptions = [
    {
        value: 'en',
        label: 'English',
    },
    {
        value: 'zh',
        label: '简体中文',
    },
];

export default function LanguageChanger({
    textColor,
    hoverBg,
    hoverTextColor,
    dropdownBg = 'bg-white',
    dropdownTextColor = 'text-black',
    dropdownBorder = true,
    dropdownShadow = true,
    dropdownItemHoverBg = 'hover:bg-gray-100',
    onSelectorStateChange,
}: Readonly<{
    textColor: string;
    hoverTextColor?: string;
    hoverBg?: string;
    /** 下拉面板背景，Tailwind 颜色名（如 'white'、'[#1a1a1a]'），默认 'white' */
    dropdownBg?: string;
    dropdownTextColor?: string;
    /** 下拉面板是否显示边框，默认 true */
    dropdownBorder?: boolean;
    /** 下拉面板是否显示阴影，默认 true */
    dropdownShadow?: boolean;
    /** 下拉选项 hover 的 Tailwind class，默认 'hover:bg-gray-100' */
    dropdownItemHoverBg?: string;
    onSelectorStateChange?: (state: boolean) => void;
}>) {
    const { i18n } = useTranslation();
    const [openLocaleSelector, setOpenLocaleSelector] = useState(false);
    const currentLocale = i18n.language;
    const searchParams = useSearchParams();
    const currentPathname = usePathname();
    const [hovered, setHovered] = useState(false);
    const [pendingLocale, setPendingLocale] = useState<string | null>(null);
    const [isPending, startTransition] = useTransition();

    // 路由完成后重置 pendingLocale
    useEffect(() => {
        setPendingLocale(null);
    }, [currentLocale]);

    const displayLocale = pendingLocale ?? currentLocale;

    const handleChange = (newLocale: string) => {
        if (!newLocale || currentLocale === newLocale || isPending) {
            return;
        }

        // 乐观更新：立即反映语言切换
        setPendingLocale(newLocale);

        // set cookie for next-i18n-router
        const days = 30;
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `NEXT_LOCALE=${newLocale};expires=${date.toUTCString()};path=/`;

        const newPath = getLocalizedPathname(currentPathname, newLocale);

        // 获取当前的查询参数
        const queryString = new URLSearchParams(searchParams).toString();
        const newPathWithQuery = queryString
            ? `${newPath}?${queryString}`
            : newPath;

        if (typeof window !== 'undefined') {
            window.sessionStorage.setItem(
                LOCALE_SCROLL_RESTORE_KEY,
                JSON.stringify({
                    pathname: newPath,
                    y: window.scrollY,
                    createdAt: Date.now(),
                }),
            );
            window.history.scrollRestoration = 'manual';
            window.location.href = newPathWithQuery;
        }
    };

    useEffect(() => {
        if (onSelectorStateChange) {
            onSelectorStateChange(openLocaleSelector);
        }

        const handleScroll = () => {
            if (openLocaleSelector) {
                setOpenLocaleSelector(false);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [openLocaleSelector, onSelectorStateChange]);

    const finalHoverBg = hoverBg ?? '#efefef';

    return (
        <div className="j-l2 relative z-[9999]">
            <div
                className="hidden rounded-[4px] p-[5px] hover:cursor-pointer sm:block"
                style={{
                    backgroundColor: hovered ? finalHoverBg : undefined,
                    color:
                        hovered && hoverTextColor ? hoverTextColor : textColor,
                }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <div className="group flex flex-row items-center gap-[4px]">
                    {isPending || pendingLocale !== null ? (
                        <svg
                            width={16}
                            height={16}
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                                animation: 'spin 0.8s linear infinite',
                                color:
                                    hovered && hoverTextColor
                                        ? hoverTextColor
                                        : textColor,
                            }}
                        >
                            <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
                            <circle
                                cx="8"
                                cy="8"
                                r="6"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeDasharray="25 13"
                                strokeLinecap="round"
                            />
                        </svg>
                    ) : (
                        <EarthIcon
                            primaryColor={
                                hovered && hoverTextColor
                                    ? hoverTextColor
                                    : textColor
                            }
                            width={16}
                            height={16}
                            useGroupHover
                        />
                    )}
                    <MenuDropdownButton
                        showDropdown={true}
                        title={displayLocale == 'en' ? 'English' : '简体中文'}
                        dropdownOpen={openLocaleSelector}
                        onClick={() => {
                            setOpenLocaleSelector((pre) => !pre);
                        }}
                    />
                </div>
            </div>

            <div
                className={clsx(
                    'absolute right-0 top-[40px] z-[99999] flex flex-col rounded-[8px] py-[8px]',
                    dropdownTextColor,
                    dropdownBg,
                    dropdownBorder && 'border',
                    dropdownShadow && 'shadow-md',
                    {
                        hidden: !openLocaleSelector,
                        block: openLocaleSelector,
                    },
                )}
            >
                {languageOptions.map((option) => (
                    <button
                        key={option.value}
                        className={clsx(
                            'flex h-[30px] w-[160px] flex-row items-center gap-[8px] pl-[16px]',
                            dropdownItemHoverBg,
                            dropdownTextColor,
                        )}
                        onClick={() => {
                            handleChange(option.value);
                            setOpenLocaleSelector(false);
                        }}
                    >
                        {displayLocale == option.value ? (
                            <SelectedIcon />
                        ) : (
                            <div className="h-[20px] w-[20px]"></div>
                        )}
                        <div className="j-t2">{option.label}</div>
                    </button>
                ))}
            </div>
            <div className="flex flex-row divide-x sm:hidden">
                {languageOptions.map((option) => (
                    <button
                        key={option.value}
                        disabled={isPending}
                        className={clsx(
                            'flex flex-row items-center gap-[6px] px-[16px]',
                            {
                                'text-[#6C49FF]': displayLocale == option.value,
                                'text-black': displayLocale != option.value,
                                'opacity-60':
                                    isPending && displayLocale != option.value,
                            },
                        )}
                        onClick={() => {
                            handleChange(option.value);
                        }}
                    >
                        <div className="j-h5">{option.label}</div>
                        {(isPending || pendingLocale !== null) &&
                            displayLocale == option.value && (
                                <svg
                                    width={14}
                                    height={14}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{
                                        animation: 'spin 0.8s linear infinite',
                                        flexShrink: 0,
                                    }}
                                >
                                    <circle
                                        cx="8"
                                        cy="8"
                                        r="6"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeDasharray="25 13"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            )}
                    </button>
                ))}
            </div>
        </div>
    );
}
